import React, { Component } from "react";
import Splash from "components/Common/Splash";
import Footer from "components/Common/Footer";

import PropTypes from "prop-types";
import colors from "stylesheets/utilities/colors.scss";

import "./style.scss";

export default class PasswordResetEmailConfirmation extends Component {
  /**
    * show reset email page
    */
  sendToResetPage = () => {
    const { sendToResetPage } = this.props;
    sendToResetPage();
  }

  /**
    * @param {Object} e
    */
  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.sendToResetPage();
    }
  }

  /**
    * @returns {HTMLElement}
    */
  resetEmail() {
    const { email } = this.props;

    return (
      <>
        <div className="PasswordResetEmailConfirmation__p">We sent an email to {email} to reset your password. Allow 30 seconds for it to arrive.&nbsp;
          <span className="Login__link" role="link" onKeyPress={this.handleKeyPress} tabIndex={0} onClick={this.sendToResetPage}>
            Wrong email address?
          </span>
        </div>
        <div className="PasswordResetEmailConfirmation__p">
          If you don&#39;t see an email, please check your junk or spam folder.&nbsp;
          <a href="mailto:help@ada.support">
            I didn’t receive an email.
          </a>
        </div>
      </>
    );
  }

  /**
 * @returns {HTMLElement}
 */
  render() {
    const { hideConfirmation } = this.props;

    return (
      <>
        <div className="Login__splash-page">
          <Splash
            icon="Send"
            fillColor={colors.colorBlack}
            title="Check Your Inbox"
            description={this.resetEmail()}
            buttonLabel="Log In"
            buttonIcon="SignIn"
            buttonAction={hideConfirmation}
          />
        </div>
        <Footer />
      </>
    );
  }
}


PasswordResetEmailConfirmation.propTypes = {
  email: PropTypes.string.isRequired,
  sendToResetPage: PropTypes.func.isRequired,
  hideConfirmation: PropTypes.func.isRequired
};
